import { render } from "./FpuiInputLabel.vue?vue&type=template&id=40cd9982&lang=pug"
import script from "./FpuiInputLabel.vue?vue&type=script&lang=js"
export * from "./FpuiInputLabel.vue?vue&type=script&lang=js"

import "./FpuiInputLabel.vue?vue&type=style&index=0&id=40cd9982&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__